<template>
  <div class="space-y-8 content-block">
    <!-- Control panel for filters -->
    <ControlPanel @filters-change="onFilterChange" />

    <!-- Metrics cards -->
    <MetricsCards />
  </div>
</template>

<script setup>
/* global defineEmits */
import { MetricsCards, ControlPanel } from './index.js';

const emit = defineEmits(['filter-change']);

function onFilterChange(payload) {
  emit('filter-change', payload);
}
</script>
